export default "__VITE_ASSET__Ckljp_NV__"